import { render, staticRenderFns } from "./tasks.vue?vue&type=template&id=0a07bc3a&scoped=true"
import script from "./tasks.vue?vue&type=script&lang=js"
export * from "./tasks.vue?vue&type=script&lang=js"
import style0 from "./tasks.vue?vue&type=style&index=0&id=0a07bc3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a07bc3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a07bc3a')) {
      api.createRecord('0a07bc3a', component.options)
    } else {
      api.reload('0a07bc3a', component.options)
    }
    module.hot.accept("./tasks.vue?vue&type=template&id=0a07bc3a&scoped=true", function () {
      api.rerender('0a07bc3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aiSession/tasks.vue"
export default component.exports